import { render } from "./BaseModal.vue?vue&type=template&id=05c0bf1c"
const script = {}

import "./BaseModal.vue?vue&type=style&index=0&id=05c0bf1c&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__